import React from "react";
import { useForm } from "react-hook-form";
import useFormActions from "../useFormActions";
import StepWrapper from "./StepWrapper";
import CheckboxGroup from "../../common/forms/components/CheckboxGroup";
import { subscriptionStepProps } from "../../common/types/subscription";

export default function Step3({
	formStep,
	subtitle,
	title,
}: subscriptionStepProps) {
	const { onUpdateForm } = useFormActions();
	const { control, handleSubmit } = useForm();

	return (
		<StepWrapper
			formStep={formStep}
			onSubmit={handleSubmit(onUpdateForm)}
			title={title}
			subtitle={subtitle}
		>
			<CheckboxGroup
				checkboxes={[
					{ key: "CMC", label: "Commercial Aviation" },
					{ key: "BZA", label: "Business Jets" },
				]}
				control={control}
				fieldKey="industrySegments"
				legend="Choose one or more options."
				required
				validate={{
					segment: (value) => value.length > 0,
				}}
			/>
		</StepWrapper>
	);
}
